import React from 'react';
import { IItem, ItemTypeEnum } from '../../model';
import Plan from './Plan';
import OneTimePurchaseItem from './OneTimePurchaseItem';
import CustomPlan from './CustomPlan';

interface IProps{
  item: IItem;
}

const Item = ({ item }: IProps) => {
  if(item.type === ItemTypeEnum.custom){
    return <CustomPlan key={item.plan_id + 'state'} plan={item}/>
  }

  if(item.type === ItemTypeEnum.plan){
    return <Plan key={item.plan_id + 'state' + item.isAdditional} plan={item}/>
  }

  return <OneTimePurchaseItem key={item.plan_id} item={item} />;
};

export default Item;
